const getSlot = ({ id }) =>
  window.googletag
    ?.pubads?.()
    .getSlots()
    .find(slot => slot.getSlotElementId() === id) || null;

export default getSlot;
